import { Head } from '@/components';
import { MyParcels } from './components/MyParcels';
import type {
  IMainTranslation,
  INotificationTranslation,
  IPmtOnboardingPopup,
  IPmtPage,
  ITrackingTranslation,
} from './interfaces';

interface IPMTProps {
  mainTranslation: IMainTranslation;
  trackingTranslation: ITrackingTranslation;
  pmtOnboardingPopUp: IPmtOnboardingPopup;
  pmtEmailSyncOnboardingPopUp: IPmtOnboardingPopup;
  notificationTranslation: INotificationTranslation;
  pmtPageData: IPmtPage | null;
}

export const PMT = ({
  mainTranslation,
  trackingTranslation,
  pmtOnboardingPopUp,
  pmtEmailSyncOnboardingPopUp,
  notificationTranslation,
  pmtPageData,
}: IPMTProps) => {
  return (
    <>
      {pmtPageData?.seo && <Head {...pmtPageData.seo} />}
      <MyParcels
        mainTranslation={mainTranslation}
        trackingTranslation={trackingTranslation}
        pmtOnboardingPopUp={pmtOnboardingPopUp}
        pmtEmailSyncOnboardingPopUp={pmtEmailSyncOnboardingPopUp}
        notificationTranslation={notificationTranslation}
        pmtPageData={pmtPageData}
      />
    </>
  );
};
